// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__vs1yi","contactform":"contact_contactform__f6XCP"};